export function getCategoryColor(category: string): string {
  switch (category.toLowerCase()) {
    case 'basis trading':
      return '--violet-500'
    case 'bridging':
      return '--cyan-500'
    case 'cdp':
      return '--pink-500'
    case 'credit':
      return '--fuchsia-500'
    case 'lending':
      return '--teal-500'
    case 'liquid staking':
      return '--orange-500'
    case 'market making':
      return '--fuchsia-500'
    case 'rwa':
      return '--violet-500'
    case 'synthetic':
      return '--orange-500'
    case 'yield aggregator':
      return '--violet-500'
    case 'direct protocol lending':
      return '--teal-500'
    case 'curated lending':
      return '--teal-500'
    case 'shared lending pool':
      return '--teal-500'
    case 'isolated market':
      return '--pink-500'
    case 'dex-integrated lending':
      return '--cyan-500'
    case 'protocol savings rate':
      return '--fuchsia-500'
    case 'safety module':
      return '--orange-500'
    case 'risk cover':
      return '--fuchsia-500'
    default:
      return '--teal-500'
  }
}
